module.exports = __webpack_public_path__ + "assets/images/boundaries/comparison-legend/desktop.svg?v=c6763cf3";